module.exports = __webpack_public_path__ + "static/media/Mar_2026_1.de644d8b.webp";